// extracted by mini-css-extract-plugin
export default {"headContainer":"PageHead_headContainer_Khvdw","userInfos":"PageHead_userInfos_ukcRo"};